<script>
    import { url } from '@sveltech/routify'
    import { Error503Page } from 'totalinvoice-frontend-core'
</script>

<Error503Page url={$url('/')} />
